import shuffle from '../shuffle';
import randomElement from '../randomElement';

function Order(minigameData){
    var task = randomElement(minigameData.data.questions);
    var list = shuffle(task.variants.map((x, i) => ({ x, i })));
    return {
        title: minigameData.title,
        question: task.qst,
        correct: list.map(({ i }) => i),
        list: list.map(({ x }) => x),
    };
}

export default Order;